module.exports = function () { /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 275
 ** module chunks = 99 100 101 234 235
 **/